export default "__VITE_ASSET__CXXpjHii__"